// extracted by mini-css-extract-plugin
module.exports = {"logo":"SideMenu_logo__3NZ0-"};